module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAANCAYAAAE1YMXLAAAAAXNSR0IArs4c6QAAARlJREFUOBGtUbFOw0AMtc85RtYO/ML1NqRulboxdEBMlYqEmGBJ0v5Jl/4AMx/AH7DCDyAhlooPoBKJzZ3goiQNp1TtLbbfs599NsDfI5O9Bz9iaZgWnTQNs+8doqdorU6b/NaHqob9usiyg+0FaJtmZNJtKEI38geInAUgahE+o7wn2x0oVqFtfq8Go1PePL/F8irOzS5kF1MPYIVGHLf9khTO0VdG8hpUf2WE60ZlV1CfuYuvML+NxOaTAPQaIyS37YnJ5iXIAyB+oYLL4mX1VM85SDwIaZPeMcDa3aJwjWbl6+rRc6jtcgTM5yHxECvIVyIwdrKsCG8SEUYEOcoPGoMJq6OI/reWpNFtzyAc1O17i4QX7YP+ADzeUqZopqKaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Arrow.png
// module id = 1yhh
// module chunks = 1